<template>
  <div>
    <CustomHeader
      :title="title"
      :subtitle="subtitleCustomHeader"
      :fectchPastTime="fectchPastTime"
      :fectchRealTime="fectchRealTime"
      :searchInputHeader="searchInputHeader"
      :generatePDF="generatePDF"
      :prediction="prediction"
      :showFiltersAndExportButton="false"
      :buttons="buttonsCustomHeader"
      :pillLabels="pillLabelsCustomHeader"
    />
    <Widget />
    <div id="interactive-map" class="map-container" />
    <div id="windy" class="map-container" style="display: none" />
    <Sidebar
      :visible.sync="busStationSidebar"
      :base-z-index="1000"
      position="right"
      class="w-full md:w-55rem lg:w-70rem"
    >
      <InsightsRodoviario :citiesString="citiesString" v-if="!isRealTime" :roleIdProp="roleId" />
      <div class="sidebar-interactive-map-container" v-if="isRealTime">
        <div class="sidebar-interactive-map-header">
          <img src="/images/rodoviaria.png" />
          <span v-if="!predictArrivalsDepartures" class="sidebar-interactive-map-title">
            Fluxo Rodoviário
          </span>
        </div>
      </div>
      <TabView v-if="isRealTime">
        <TabPanel header="Chegadas">
          <CustomSkeleton v-if="isLoadingPredictionInteractiveMap" type="card" />
          <div
            v-if="
              !isLoadingArrivalsData &&
              !predictArrivalsDepartures &&
              !isLoadingPredictionInteractiveMap
            "
            class="interactive-map-search-container"
          >
            <input
              v-model="searchQueryArrivals"
              type="text"
              placeholder="Buscar"
              class="search-input"
              @input="filterArrivals"
            />
          </div>
          <div
            v-if="filteredArrivals && filteredArrivals.length === 0 && !predictArrivalsDepartures"
          >
            <p>Nenhum dado encontrado</p>
          </div>
          <div v-if="predictArrivalsDepartures" class="sidebar-predict-interactive-map-card">
            <span class="sidebar-predict-interactive-map-card-text">
              A estimativa de chegadas de visitantes via rodoviária em um período de
              <strong class="sidebar-predict-interactive-map-card-text-strong">{{
                predictArrivalsDepartures.days
              }}</strong>
              dias é de
              <strong class="sidebar-predict-interactive-map-card-text-strong">{{
                predictArrivalsDepartures.rodoviariaChegada
              }}</strong>
              pessoas.
            </span>
          </div>
          <div
            v-if="
              !predictArrivalsDepartures &&
              !isLoadingArrivalsData &&
              !isLoadingPredictionInteractiveMap
            "
            v-for="(arrivals, index) in filteredArrivals"
            :key="index + 'arrivals'"
          >
            <div
              v-for="(origin, i) in arrivals.origins"
              :key="i + 'origin'"
              class="sidebar-interactive-map-card"
            >
              <div class="sidebar-interactive-map-card-company-logo">
                <img :src="`/${arrivals.operator.toLowerCase()}.png`" />
                <span class="sidebar-interactive-map-card-company-name">{{
                  arrivals.operator
                }}</span>
              </div>
              <span class="sidebar-interactive-map-card-city">{{ origin.city }}</span>
              <span class="sidebar-interactive-map-card-time">{{ origin.time }}</span>
            </div>
          </div>
        </TabPanel>
        <TabPanel header="Partidas" v-if="!predictArrivalsDepartures">
          <CustomSkeleton v-if="isLoadingPredictionInteractiveMap" type="card" />
          <div
            v-if="
              !isLoadingDepartureData &&
              !predictArrivalsDepartures &&
              !isLoadingPredictionInteractiveMap
            "
            class="interactive-map-search-container"
          >
            <input
              v-model="searchQueryDepartures"
              type="text"
              placeholder="Buscar"
              class="search-input"
              @input="filterDepartures"
            />
          </div>
          <div
            v-if="
              filteredDepartures && filteredDepartures.length === 0 && !predictArrivalsDepartures
            "
          >
            <p>Nenhum dado encontrado</p>
          </div>
          <div v-if="predictArrivalsDepartures" class="sidebar-predict-interactive-map-card">
            <span class="sidebar-predict-interactive-map-card-text">
              A estimativa de chegadas de visitantes via rodoviária em um período de
              <strong class="sidebar-predict-interactive-map-card-text-strong">{{
                predictArrivalsDepartures.days
              }}</strong>
              dias é de
              <strong class="sidebar-predict-interactive-map-card-text-strong">{{
                predictArrivalsDepartures.rodoviariaChegada
              }}</strong>
              pessoas.
            </span>
          </div>
          <div
            v-if="
              !predictArrivalsDepartures &&
              !isLoadingArrivalsData &&
              !isLoadingPredictionInteractiveMap
            "
            v-for="(departures, index) in filteredDepartures"
            :key="index + 'departures'"
          >
            <div
              v-for="(destination, i) in departures.destinations"
              :key="i + 'origin'"
              class="sidebar-interactive-map-card"
            >
              <div class="sidebar-interactive-map-card-company-logo">
                <img :src="`/${departures.operator.toLowerCase()}.png`" />
                <span class="sidebar-interactive-map-card-company-name">{{
                  departures.operator
                }}</span>
              </div>
              <span class="sidebar-interactive-map-card-city">{{ destination.city }}</span>
              <span class="sidebar-interactive-map-card-time">{{ destination.time }}</span>
            </div>
          </div>
        </TabPanel>
      </TabView>
    </Sidebar>
    <Sidebar
      :visible.sync="airportSidebar"
      :base-z-index="1000"
      position="right"
      class="w-full md:w-55rem lg:w-70rem"
    >
      <InsightsAeroviario :citiesString="citiesString" v-if="!isRealTime" :roleIdProp="roleId" />
      <div class="sidebar-interactive-map-container" v-if="isRealTime">
        <div class="sidebar-interactive-map-header">
          <img src="/images/aeroporto.png" />
          <span v-if="!predictArrivalsDepartures" class="sidebar-interactive-map-title">
            Fluxo Aeroviário
          </span>
        </div>
      </div>
      <TabView v-if="isRealTime">
        <TabPanel header="Chegadas">
          <CustomSkeleton v-if="isLoadingPredictionInteractiveMap" type="card" />
          <div
            v-if="
              !isLoadingAnacArrivalsData &&
              !predictArrivalsDepartures &&
              filteredAnacArrivals &&
              filteredAnacArrivals.length > 0 &&
              !isLoadingPredictionInteractiveMap
            "
            class="interactive-map-search-container"
          >
            <input
              v-model="searchQueryAnacArrivals"
              type="text"
              placeholder="Buscar"
              class="search-input"
              @input="filterAnacArrivals"
            />
          </div>
          <div
            v-if="
              filteredAnacArrivals &&
              filteredAnacArrivals.length === 0 &&
              !predictArrivalsDepartures
            "
          >
            <p>Nenhum dado encontrado</p>
          </div>
          <div v-if="predictArrivalsDepartures" class="sidebar-predict-interactive-map-card">
            <span class="sidebar-predict-interactive-map-card-text">
              A estimativa de chegadas de visitantes via aeroporto em um período de
              <strong class="sidebar-predict-interactive-map-card-text-strong">{{
                predictArrivalsDepartures.days
              }}</strong>
              dias é de
              <strong class="sidebar-predict-interactive-map-card-text-strong">{{
                predictArrivalsDepartures.aeroportoChegada
              }}</strong>
              pessoas.
            </span>
          </div>
          <div
            v-if="
              !predictArrivalsDepartures &&
              !isLoadingArrivalsData &&
              !isLoadingPredictionInteractiveMap
            "
            v-for="(arrivals, index) in filteredAnacArrivals"
            :key="index + 'arrivals'"
            class="sidebar-interactive-map-card"
          >
            <div class="sidebar-interactive-map-card-company-logo">
              <img :src="`/${arrivals.company}.png`" />
              <span class="sidebar-interactive-map-card-company-name">{{ arrivals.company }}</span>
            </div>
            <span class="sidebar-interactive-map-card-city">{{
              arrivals.airport_origin_city
            }}</span>
            <span class="sidebar-interactive-map-card-time">
              {{ arrivals.end_full_date }}
            </span>
          </div>
        </TabPanel>

        <TabPanel header="Partidas" v-if="!predictArrivalsDepartures">
          <CustomSkeleton v-if="isLoadingPredictionInteractiveMap" type="card" />
          <div
            v-if="
              !isLoadingAnacDeparturesData &&
              !predictArrivalsDepartures &&
              filteredAnacArrivals &&
              filteredAnacArrivals.length > 0 &&
              !isLoadingPredictionInteractiveMap
            "
            class="interactive-map-search-container"
          >
            <input
              v-model="searchQueryAnacDepartures"
              type="text"
              placeholder="Buscar"
              class="search-input"
              @input="filterAnacDepartures"
            />
          </div>
          <div
            v-if="
              filteredAnacDepartures &&
              filteredAnacDepartures.length === 0 &&
              !predictArrivalsDepartures
            "
          >
            <p>Nenhum dado encontrado</p>
          </div>
          <div v-if="predictArrivalsDepartures" class="sidebar-predict-interactive-map-card">
            <span class="sidebar-predict-interactive-map-card-text">
              A estimativa de partida de visitantes via aeroporto em um período de
              <strong class="sidebar-predict-interactive-map-card-text-strong">{{
                predictArrivalsDepartures.days
              }}</strong>
              dias é de
              <strong class="sidebar-predict-interactive-map-card-text-strong">{{
                predictArrivalsDepartures.aeroportoPartida
              }}</strong>
              pessoas.
            </span>
          </div>
          <div
            v-if="
              !predictArrivalsDepartures &&
              !isLoadingArrivalsData &&
              !isLoadingPredictionInteractiveMap
            "
            v-for="(arrivals, index) in filteredAnacDepartures"
            :key="index + 'arrivals'"
            class="sidebar-interactive-map-card"
          >
            <div class="sidebar-interactive-map-card-company-logo">
              <img :src="`/${arrivals.company}.png`" />
              <span class="sidebar-interactive-map-card-company-name">{{ arrivals.company }}</span>
            </div>
            <span class="sidebar-interactive-map-card-city">{{
              arrivals.airport_destiny_city
            }}</span>
            <span class="sidebar-interactive-map-card-time"> {{ arrivals.start_full_date }}</span>
          </div>
        </TabPanel>
      </TabView>
    </Sidebar>

    <Sidebar
      :visible.sync="maritimeSidebar"
      :base-z-index="1000"
      position="right"
      class="w-full md:w-55rem lg:w-70rem"
    >
      <InsightsMaritimo :citiesString="citiesString" v-if="!isRealTime" :roleIdProp="roleId" />
      <div class="sidebar-interactive-map-container" v-if="isRealTime">
        <div class="sidebar-interactive-map-header">
          <img src="/images/maritmo.png" />
          <span v-if="!predictArrivalsDepartures" class="sidebar-interactive-map-title">
            Fluxo Marítimo
          </span>
        </div>
      </div>
      <TabView v-if="isRealTime">
        <TabPanel header="Chegadas">
          <p v-if="!predictArrivalsDepartures">Sem acesso a dados marítimo</p>
          <div v-if="predictArrivalsDepartures" class="sidebar-predict-interactive-map-card">
            <span class="sidebar-predict-interactive-map-card-text">
              Sem acesso a dados para realizar previsões
            </span>
          </div>
        </TabPanel>

        <TabPanel header="Partidas" v-if="!predictArrivalsDepartures">
          <p v-if="!predictArrivalsDepartures">Sem acesso a dados marítimo</p>
          <div v-if="predictArrivalsDepartures" class="sidebar-predict-interactive-map-card">
            <span class="sidebar-predict-interactive-map-card-text">
              Sem acesso a dados para realizar previsões
            </span>
          </div>
        </TabPanel>
      </TabView>
    </Sidebar>
    <InteractiveMapInsights :citiesString="citiesString" :roleIdProp="roleId" />
    <Dialog position="center" :visible.sync="showLoadingDialog" :dismissable-mask="true">
      <div class="dialog-loading-map">
        <ProgressSpinner />
        <span class="dialog-loading-map-text">{{ textDialog }}</span>
      </div>
    </Dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import { mapState } from 'pinia'
import axios from 'axios'
import moment from 'moment'
import ProgressSpinner from 'primevue/progressspinner'
import Dialog from 'primevue/dialog'
import Sidebar from 'primevue/sidebar'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import CustomSkeleton from '@/Shared/CustomSkeleton'
import { useInteractiveMap } from '../../../stores/interactiveMap'
import { useCustomHeader } from '../../../stores/customHeader'
import CustomHeader from '../CustomHeader/CustomHeader'
import MapControl from './Components/MapControl'
import Widget from './Components/Widget/Widget'
import InteractiveMapInsights from './Components/Insights/InteractiveMapInsights.vue'
import Layout from '../Layout.vue'
import { Chart, registerables } from 'chart.js'

Chart.register(...registerables)

export default {
  name: 'InteractiveMap',
  components: {
    CustomHeader,
    Sidebar,
    TabView,
    TabPanel,
    CustomSkeleton,
    Widget,
    InteractiveMapInsights,
    Dialog,
    ProgressSpinner,
  },
  layout: Layout,
  props: {
    citiesString: String,
    user: Number,
    roleId: Number,
  },
  data() {
    return {
      title: ' Mapa Preditivo',
      titleCustomHeader: 'Dados em tempo real',
      changeMapType: 'transport',
      textDialog: 'Carregando mapa...',
      showLoadingDialog: true,
      airportSidebar: false,
      isLoadingChart: true,
      isLoadingArrivalsData: true,
      isLoadingAnacArrivalsData: true,
      isLoadingAnacDeparturesData: true,
      isLoadingDepartureData: true,
      isRealTime: true,
      busStationSidebar: false,
      maritimeSidebar: false,
      chartBusStation: null,
      arrivalsData: [],
      arrivalsAnacData: [],
      departuresAnacData: [],
      departuresData: [],
      filteredDepartures: [],
      filteredArrivals: [],
      filteredAnacArrivals: [],
      filteredAnacDepartures: [],
      searchQueryArrivals: '',
      searchQueryDepartures: '',
      searchQueryAnacDepartures: '',
      searchQueryAnacArrivals: '',
      cityCount: [],
      insights: [],
      buttonStyles: {
        backgroundColor: 'white',
        color: '#37434A',
        padding: '8px 12px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        borderRadius: '100px',
        border: 'none',
        cursor: 'pointer',
      },
      anacDayliArrival: 0,
      anacDayliDeparture: 0,
      pillLabelsCustomHeader: [
        { label: 'Pŕoximos 7 dias', days: 7, enabled: true },
        { label: 'Pŕoximos 15 dias', days: 15, enabled: true },
        { label: 'Pŕoximos 30 dias', days: 30, enabled: true },
        { label: 'Pŕoximos 6 meses', days: 180, enabled: true },
      ],
    }
  },
  computed: {
    ...mapState(useInteractiveMap, ['predictArrivalsDepartures']),
    ...mapState(useInteractiveMap, ['getPredictionDays']),
    ...mapState(useCustomHeader, ['isLoadingPredictionInteractiveMap']),
    ...mapState(useCustomHeader, ['togleIsLoadingPredictionInteractiveMap']),
    ...mapState(useCustomHeader, ['togleIsLoadingPredictionTraffic']),
    ...mapState(useCustomHeader, ['subtitleCustomHeader']),
    ...mapState(useCustomHeader, ['getSubtitleCustomHeader']),
    ...mapState(useCustomHeader, ['getSelectedButtonId']),
    ...mapState(useCustomHeader, ['getButtonsCustomHeader']),
    ...mapState(useCustomHeader, ['buttonsCustomHeader']),
  },
  async mounted() {
    setTimeout(async () => {
      this.getSubtitleCustomHeader('Dados em tempo real')
      this.getSelectedButtonId(2)
      const mapOptions = {
        tilt: 10,
        heading: 5,
        zoom: 13,
        center: { lat: -25.597576285627483, lng: -54.48808204999569 },
      }

      const locations = [
        {
          lat: -25.52032,
          lng: -54.56379,
          title: 'Terminal Rodoviária Internacional',
          type: 'rodoviaria',
        },
        {
          lat: -25.597576285627483,
          lng: -54.48808204999569,
          title: 'Aeroporto Internacional de Foz',
          type: 'aeroporto',
        },
        {
          lat: -25.58996788529244,
          lng: -54.578903346031055,
          title: 'Kattamaram II',
          type: 'maritmo',
        },
      ]

      await this.$initMap('interactive-map', mapOptions, locations, this.addCustomControls)
      this.$root.$on('marker-click', this.handleMarkerClick)
      const bus = await this.getBusStationArrivals()
      const anac = await this.getAnacArrivals()
      await this.getBusStationDepartures()
      await this.getAnacDepartures()
      this.countCities(bus, anac)
    }, 1000)
    this.$root.$on('map-loaded', () => {
      this.showLoadingDialog = false
    })
  },
  methods: {
    customFormatter(date) {
      moment.locale('pt-br')
      return moment(date).format('L')
    },
    async prediction(days) {
      this.isRealTime = false
      this.getPredictionDays(days)
      this.getPredictionDays(days)
      const interactiveMapStore = useInteractiveMap()
      const customHeader = useCustomHeader()
      this.togglePillLabelsCustomHeader(interactiveMapStore.mapType)
      const titleDays = days === 180 ? 'próximos 6 meses' : `próximos ${days} dias`
      this.getSubtitleCustomHeader(`Análise preditiva para ${titleDays}`)
      if (interactiveMapStore.mapType === 'traffic') {
        try {
          this.showLoadingDialog = true
          this.textDialog = 'Carregando dados de previsão'
          customHeader.togleIsLoadingPredictionTraffic()
          const response = await axios.post('/api/transport-modes/predict/traffic', {
            cities: interactiveMapStore.cityCount,
            days,
            citiesString: this.citiesString,
            user: this.user,
          })
          interactiveMapStore.getPredictTrafficData(response.data)
        } catch (error) {
          customHeader.togleIsLoadingPredictionTraffic()
          console.log(error)
        } finally {
          customHeader.togleIsLoadingPredictionTraffic()
          this.showLoadingDialog = false
        }
      }
    },
    createSentimentChart() {
      const canvas = document.getElementById('bus-station-assent-chart')
      const ctx = canvas.getContext('2d')
      if (this.chartBusStation) {
        this.chartBusStation.destroy()
      }
      this.chartBusStation = new Chart(ctx, {
        type: 'doughnut',
        data: {
          datasets: [
            {
              data: [75, 25],
              backgroundColor: ['#7749F8', '#CAD2D6'],
            },
          ],
        },
        options: {
          responsive: true,
          rotation: -90,
          circumference: 180,
          plugins: {
            legend: { display: true },
            title: { display: false },
            tooltip: {
              enabled: true,
              intersect: true,
              callbacks: {
                label: function (context) {
                  return `${context.label}: ${context.raw}%`
                },
              },
            },
          },
        },
      })
      this.isLoadingChart = false
    },

    addCustomControls(map, changeMapType = 'transport') {
      const controlDiv = document.createElement('div')
      controlDiv.style.margin = '10px'

      const ControlComponent = Vue.extend(MapControl)
      const instance = new ControlComponent({
        propsData: {
          changeMapType,
          isLoadingArrivalsData: this.isLoadingArrivalsData,
          addCustomControls: this.addCustomControls,
          prediction: this.prediction,
        },
      })

      instance.$mount()
      controlDiv.appendChild(instance.$el)

      // eslint-disable-next-line no-undef
      map.controls[google.maps.ControlPosition.TOP_RIGHT].push(controlDiv)
    },
    async getBusStationDepartures() {
      try {
        this.isLoadingDepartureData = true
        const response = await axios.get(
          '/api/transport-modes/interactive-map/bus-station/departures?city=foz-do-iguacu',
        )
        this.departuresData = response.data
        this.filteredDepartures = this.departuresData.timetable_item_list
        this.isLoadingDepartureData = false
      } catch (error) {}
    },
    async getBusStationArrivals() {
      try {
        this.isLoadingArrivalsData = true
        const response = await axios.get(
          '/api/transport-modes/interactive-map/bus-station/arrivals?city=foz-do-iguacu',
        )
        this.arrivalsData = response.data
        this.filteredArrivals = this.arrivalsData.timetable_item_list
        this.isLoadingArrivalsData = false
        return this.filteredArrivals
      } catch (error) {}
    },
    async getAnacArrivals() {
      try {
        this.isLoadingAnacArrivalsData = true
        const response = await axios.get('/api/transport-modes/interactive-map/anac/arrivals')
        this.arrivalsAnacData = response.data
        this.filteredAnacArrivals = this.arrivalsAnacData
        this.isLoadingAnacArrivalsData = false
        const dailyArrival = response.data.filter((arrival) => {
          const currentDate = moment().format('YYYY-MM-DD')
          const arrivalEndDate = moment(arrival.end_date).format('YYYY-MM-DD')
          return currentDate === arrivalEndDate
        })
        this.anacDayliArrival = dailyArrival.length
        return this.filteredAnacArrivals
      } catch (error) {}
    },
    async getAnacDepartures() {
      try {
        this.isLoadingAnacDeparturesData = true
        const response = await axios.get('/api/transport-modes/interactive-map/anac/departures')
        this.departuresAnacData = response.data
        this.filteredAnacDepartures = this.departuresAnacData
        this.isLoadingAnacDeparturesData = false
        const dailyDepartures = response.data.filter((arrival) => {
          const currentDate = moment().format('YYYY-MM-DD')
          const arrivalEndDate = moment(arrival.start_date).format('YYYY-MM-DD')
          return currentDate === arrivalEndDate
        })
        this.anacDayliDeparture = dailyDepartures.length
      } catch (error) {}
    },
    countCities(arrivals, anacArrivals) {
      const cityCount = {}
      let totalArrivals = 0
      const interactiveMapStore = useInteractiveMap()

      // Contar estados dos dados de ônibus
      arrivals.forEach((item) => {
        item.origins.forEach((origin) => {
          const cityState = origin.city.split('-')
          const state = cityState[cityState.length - 1].trim() // Obter a parte do estado
          totalArrivals++
          if (cityCount[state]) {
            cityCount[state].count++
          } else {
            cityCount[state] = {
              count: 1,
            }
          }
        })
      })

      // Contar estados dos dados da ANAC
      anacArrivals.forEach((item) => {
        let state = item.airport_origin_state // Estado da origem no dado da ANAC
        if (state === 'Guarulhos') {
          state = 'SP'
        }
        if (state === 'Recife') {
          state = 'PE'
        }
        if (state === 'Rio De Janeiro') {
          state = 'RJ'
        }
        totalArrivals++
        if (cityCount[state]) {
          cityCount[state].count++
        } else {
          cityCount[state] = {
            count: 1,
          }
        }
      })

      let percentages = Object.entries(cityCount).map(([state, data]) => ({
        state,
        count: data.count,
        percentage: ((data.count / totalArrivals) * 100).toFixed(1),
      }))

      const totalPercentage = percentages.reduce(
        (acc, item) => acc + parseFloat(item.percentage),
        0,
      )

      const difference = 100 - totalPercentage

      if (difference !== 0) {
        const maxItem = percentages.reduce((prev, current) =>
          parseFloat(prev.percentage) > parseFloat(current.percentage) ? prev : current,
        )
        maxItem.percentage = (parseFloat(maxItem.percentage) + difference).toFixed(1)
      }
      interactiveMapStore.getCityCount(percentages)
    },

    handleMarkerClick(markerData) {
      this.isLoadingChart = true
      if (markerData.type === 'aeroporto') {
        this.airportSidebar = !this.airportSidebar
      }
      if (markerData.type === 'rodoviaria') {
        this.busStationSidebar = !this.busStationSidebar
      }
      if (markerData.type === 'maritmo') {
        this.maritimeSidebar = !this.maritimeSidebar
      }
    },
    filterArrivals() {
      const query = this.searchQueryArrivals.toLowerCase()
      if (query.length >= 3) {
        this.filteredArrivals = this.arrivalsData.timetable_item_list.filter(
          (arrival) =>
            arrival.operator.toLowerCase().includes(query) ||
            arrival.origins.some(
              (origin) =>
                origin.city.toLowerCase().includes(query) ||
                origin.time.toLowerCase().includes(query),
            ),
        )
      } else {
        this.filteredArrivals = this.arrivalsData.timetable_item_list
      }
    },
    filterDepartures() {
      const query = this.searchQueryDepartures.toLowerCase()
      if (query.length >= 3) {
        this.filteredDepartures = this.departuresData.timetable_item_list.filter(
          (arrival) =>
            arrival.operator.toLowerCase().includes(query) ||
            arrival.destinations.some(
              (destination) =>
                destination.city.toLowerCase().includes(query) ||
                destination.time.toLowerCase().includes(query),
            ),
        )
      } else {
        this.filteredDepartures = this.departuresData.timetable_item_list
      }
    },
    filterAnacDepartures() {
      const query = this.searchQueryAnacDepartures.toLowerCase()
      if (query.length >= 3) {
        this.filteredAnacDepartures = this.departuresAnacData.filter(
          (departure) =>
            departure.company.toLowerCase().includes(query) ||
            departure.airport_destiny.toLowerCase().includes(query) ||
            departure.start_date.toLowerCase().includes(query) ||
            departure.start_hour.toLowerCase().includes(query),
        )
      } else {
        this.filteredAnacDepartures = this.departuresAnacData
      }
    },
    filterAnacArrivals() {
      const query = this.searchQueryAnacArrivals.toLowerCase()
      if (query.length >= 3) {
        this.filteredAnacArrivals = this.arrivalsAnacData.filter(
          (arrival) =>
            arrival.company.toLowerCase().includes(query) ||
            arrival.airport_origin.toLowerCase().includes(query) ||
            arrival.start_date.toLowerCase().includes(query) ||
            arrival.start_hour.toLowerCase().includes(query),
        )
      } else {
        this.filteredAnacArrivals = this.arrivalsAnacData
      }
    },

    async fectchRealTime() {
      try {
        this.getPredictionDays(0)
        this.isRealTime = true
        this.getSubtitleCustomHeader(`Dados em tempo real`)
        this.showLoadingDialog = true
        this.textDialog = 'Carregando dados em tempo real'
        const interactiveMapStore = useInteractiveMap()
        this.togleIsLoadingPredictionInteractiveMap()
        interactiveMapStore.getPredictArrivalsDepartures(null)
        const bus = await this.getBusStationArrivals()
        const anac = await this.getAnacArrivals()
        await this.getBusStationDepartures()
        await this.getAnacDepartures()
        this.countCities(bus, anac)
        this.togleIsLoadingPredictionInteractiveMap()
      } catch (error) {
        console.log('fectchRealTime error', error)
      } finally {
        this.showLoadingDialog = false
      }
    },
    async fectchPastTime(days) {
      // seu código existente
    },
    generatePDF() {
      // seu código existente
    },
    searchInputHeader(event) {
      // seu código existente
    },
    togglePillLabelsCustomHeader(mapType) {
      if (mapType === 'traffic') {
        this.pillLabelsCustomHeader = [
          { label: 'Pŕoximos 7 dias', days: 7, enabled: true },
          { label: 'Pŕoximos 15 dias', days: 15, enabled: false },
          { label: 'Pŕoximos 30 dias', days: 30, enabled: false },
          { label: 'Pŕoximos 6 meses', days: 180, enabled: false },
        ]
      } else {
        this.pillLabelsCustomHeader = [
          { label: 'Pŕoximos 7 dias', days: 7, enabled: true },
          { label: 'Pŕoximos 15 dias', days: 15, enabled: true },
          { label: 'Pŕoximos 30 dias', days: 30, enabled: true },
          { label: 'Pŕoximos 6 meses', days: 180, enabled: true },
        ]
      }
    },
  },
}
</script>

<style>
.sidebar-interactive-map-container {
  display: flex;
  flex-direction: column;
}
.sidebar-interactive-map-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 15px;
}
.sidebar-interactive-map-header img {
  margin-right: 15px;
}
.sidebar-interactive-map-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #202a2f;
}
.sidebar-interactive-map-card {
  display: flex;
  flex-direction: column;
  border: 1px solid #e6e9eb;
  border-radius: 16px;
  padding: 16px;
  gap: 24px;
}
.sidebar-interactive-map-card:last-child {
  margin-bottom: 35px;
}
.sidebar-interactive-map-card {
  margin-top: 10px;
}
.sidebar-interactive-map-card-title {
  font-size: 1rem;
  font-weight: 600;
  color: #1e293b;
}
.sidebar-interactive-map-card-text {
  font-size: 0.75rem;
  font-weight: 400;
  color: #37434a;
}
.bus-station-assent-chart {
  display: flex !important;
  width: 260px !important;
  height: 260px !important;
  align-self: center;
  margin-top: -35px;
}
.sidebar-interactive-map-card-occupation-footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: center;
  align-self: center;
  justify-content: center;
  margin-top: -70px;
}
.sidebar-interactive-map-card-occupation-footer img {
  margin-right: 15px;
}
.sidebar-interactive-map-card-company-logo {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.sidebar-interactive-map-card-company-logo img {
  width: 65px;
  height: 40px;
  margin-right: 15px;
  object-fit: contain;
  object-position: center;
}
.sidebar-interactive-map-card-company-name {
  font-size: 0.688rem;
  font-weight: 400;
  color: #37434a;
}
.sidebar-interactive-map-card-city {
  font-size: 1rem;
  font-weight: 600;
  color: #37434a;
}
.sidebar-interactive-map-card-time {
  font-size: 1.25rem;
  font-weight: 600;
  color: #202a2f;
}
.map {
  width: 100%;
  height: 80vh;
  border-radius: 16px;
}
.map-container {
  width: 100%;
  height: 90vh;
  border-radius: 15px;
  overflow: hidden;
}
.sidebar {
  position: absolute;
  top: 0;
  right: 0;
  width: 300px;
  height: 100%;
  background-color: white;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.3);
  padding: 20px;
  z-index: 1000;
  overflow: auto;
}
.custom-marker {
  background-size: cover;
  background-position: center;
  transition: transform 0.2s ease-in-out;
}
.custom-marker:hover {
  transform: scale(1.2);
}
.interactive-map-search-container {
  display: flex;
  align-items: center;
}
.search-input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  outline: none;
  transition: border-color 0.2s;
}
.search-input::placeholder {
  color: #bbb;
}
.search-input:focus {
  border-color: #7749f8;
}
.leaflet-control-container {
  display: block !important;
}
.leaflet-popup {
  bottom: -240px !important;
  width: 280px !important;
}

.sidebar-predict-interactive-map-card {
  display: flex;
  flex-direction: column;
  border: 1px solid #e6e9eb;
  border-radius: 16px;
  padding: 20px;
  gap: 25px;
  line-height: 1.8rem;
  margin-top: 20px;
  text-align: center;
  animation: glow-opacity-color 3s infinite alternate;
}

@keyframes glow-opacity-color {
  0% {
    box-shadow: 0 0 10px rgba(100, 180, 200, 0.7);
  }
  50% {
    box-shadow: 0 0 20px rgba(118, 207, 227, 0.8);
  }
  100% {
    box-shadow: 0 0 30px rgba(82, 161, 176, 1);
  }
}
.sidebar-predict-interactive-map-card-text {
  font-size: 1.2rem;
  font-weight: 400;
}
.sidebar-predict-interactive-map-card-text-strong {
  font-size: 1.7rem;
  font-weight: 600;
}
.dialog-loading-map {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.dialog-loading-map-text {
  font-size: 1rem;
  font-weight: 600;
  color: #37434a;
  margin-top: 10px;
}
.p-dialog-header {
  display: flex !important;
  align-items: flex-end !important;
  justify-content: flex-end !important;
}
</style>
